module.exports = __webpack_public_path__ + "img/profile-man-11-min.4392d2f9.jpg";